import './index.css'
import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import { createPinia } from 'pinia'
import dayjs from '@/utils/dayjs'
import { createDialog } from '@/utils/dialogs'
import translationPlugin from './translation'
import { usersStore } from './stores/user'
import { hcpProfileStore } from './stores/hcpProfile'
import { sessionStore } from './stores/session'
import { initSocket } from './socket'
import { FrappeUI, setConfig, frappeRequest, pageMetaPlugin } from 'frappe-ui'

let pinia = createPinia()
let app = createApp(App)
setConfig('resourceFetcher', frappeRequest)

// Important: First attach pinia to the app BEFORE using any store
app.use(pinia)

// Now it's safe to initialize and use the store
// First initialize from localStorage right away
const hcpStore = hcpProfileStore()
hcpStore.initFromStorage()

// Then wait for frappe to be fully initialized before fetching from server
// This ensures user session is available 
let frappeFetchAttempts = 0
const MAX_ATTEMPTS = 5

function waitForFrappeAndFetchProfile() {
	let { user } = sessionStore()
 
  // Check if frappe is properly initialized with session data
  if(user) {
    hcpStore.fetchProfileCompletion()
  } else {
    frappeFetchAttempts++
    if (frappeFetchAttempts < MAX_ATTEMPTS) {
      // Try again in 1 second
      setTimeout(waitForFrappeAndFetchProfile, 1000)
    } else {
      console.warn('Max attempts reached waiting for Frappe session. Profile completion data may not be available.')
    }
  }
}

// Start the process after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Give a short delay before first attempt
  setTimeout(waitForFrappeAndFetchProfile, 500)
})

app.use(FrappeUI)
// pinia is already initialized above
app.use(router)
app.use(translationPlugin)
app.use(pageMetaPlugin)
app.provide('$dayjs', dayjs)
app.provide('$socket', initSocket())
app.mount('#app')

const { userResource, allUsers } = usersStore()
app.provide('$user', userResource)
app.provide('$allUsers', allUsers)
app.config.globalProperties.$user = userResource
app.config.globalProperties.$dialog = createDialog
